import { Game } from "../types/game";

export const GAME_OWNER_NOT_ORGANISER_TYPE_ERROR =
  "The new owner must be an organiser or admin. This user is not an organiser type.";

const GAME_OWNER_ELIGIBLE_RULES = new Set<string>(["admin", "organiser", "club", "owner"]);

export function getGameOwnerId(game: Game): string | undefined {
  if (!game.owner) return undefined;
  return typeof game.owner === "string" ? game.owner : (game.owner as { _id?: string })?._id;
}

/** True if user is the game owner (Stripe payout recipient for paid games). */
export function userIsGameOwner(game: Game, userId?: string): boolean {
  if (!userId) return false;
  return getGameOwnerId(game) === userId;
}

/** Matches backend validateGameOwnerCandidate organiser-type check. */
export function canBeGameOwner(user: { rule?: string } | undefined): boolean {
  return !!user?.rule && GAME_OWNER_ELIGIBLE_RULES.has(user.rule);
}

/** True if user is game owner or a listed organiser. */
export function userCanManageGame(game: Game, userId?: string): boolean {
  if (!userId) return false;
  if (userIsGameOwner(game, userId)) return true;
  return game.organizers?.some((org: any) => org._id === userId || org === userId) ?? false;
}
